<template>
  <div class="wrapper">
    <!--视频-->
    <video-player id="video" class="video-player vjs-custom-skin"
      ref="videoPlayer"
      :playsinline="playsinline"
      :options="playerOptions"
      @canplay="onPlayerCanplay($event)"
    ></video-player>
    <div class="mainDetail">
      <div class="head">
        <div class="left">
          <img class="img" v-if="item.user_head" :src="item.user_head" alt="">
          <div class="img" v-else></div>
        </div>
        <div class="right">
          <div class="name" v-if="item.user_nickname">{{item.user_nickname}}</div>
          <div class="time">{{item.create_time}}</div>
        </div>
      </div>

      <div class="content">
       {{item.content}}
      </div>
      
      <div class="imgArr">
        <div class="title" v-if="item.comment_video">商品实拍视频</div>
        <div class="imgContainer1" v-if="item.comment_video">
        <div style="width:7.02rem;height:4rem" v-if="item.comment_video" class="img" @click="playVideo(item.comment_video)">
            <img style="width:7.02rem;height:4rem" :src="item.comment_video_cover+`${imgCrop}resize,w_400`" alt="">
            <div v-if="loading" class="loading">
              <van-loading class="loadingIcon" type="spinner" color="#fff" />
            </div>
            <div v-else class="player">
              <img class="playIcon" src="../../assets/images/purchaseCommdity/play.svg" alt="">
            </div>
          </div>
        </div>
        <div class="title" v-if="item.imgArr.length>0">商品实拍图</div>
        <div class="imgContainer1" v-if="item.imgArr.length==1">
          <div class="img" @click="showImage(item.imgArr, index)" v-for="(img,index) in item.imgArr" :key="index">
           <img  :src="img+`${imgCrop}resize,w_400`" alt="">
          </div>
        </div>
        <div class="imgContainer2" v-else-if="item.imgArr.length==2">
          <div class="img" @click="showImage(item.imgArr, index)" v-for="(img,index) in item.imgArr" :key="index">
           <img  :src="img+`${imgCrop}resize,w_300`" alt="">
          </div>
        </div>
        <div class="imgContainer4" v-else-if="item.imgArr.length==4">
          <div class="img" @click="showImage(item.imgArr, index)" v-for="(img,index) in item.imgArr" :key="index">
           <img  :src="img+`${imgCrop}resize,w_300`" alt="">
          </div>
        </div>
        <div class="imgContainerOther" v-else-if="item.imgArr.length>0">
          <div  @click="showImage(item.imgArr, index)" v-for="(img,index) in item.imgArr.slice(0,9)" :key="index"class="img">
           <img  :src="img+`${imgCrop}resize,w_250`" alt="">
          </div>
          <div class="img visibility" v-if="(item.comment_video?1+item.imgArr.slice(0,8).length:item.imgArr.slice(0,9).length)%3 != 0" v-for="(img,index) in new Array(3 - (item.imgArr.length+(item.comment_video?1:0)) % 3).join(',').split(',')"  :key="index">
           <img  class="" src="" alt="">
          </div>
        </div>
      </div>

      <div class="share">
        <div class="left">
          <img v-show="item.mainName" :src="item.share_head_pic" alt="">
          <div v-show="item.mainName" >{{item.mainName}}刚刚分享</div>
        </div>
        <div class="right">
          <div class="saveBtn" @click="copy" data-clipboard-action="copy" :data-clipboard-text="item.content"><div>复制文案</div></div>
          <div class="shareBtnC">
            <div @click="goqrcode" class="shareBtn">
              <img src="../../assets/images/material/share.svg" alt="">
              <span>分享</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="otherDetail">
      <div class="title">文中商品</div>
      <div class="commodity" @click="toCommodity(item.commodity_nbr)">
        <div class="commodityItem">
          <div class="left">
            <img :src="item.commodity_logo+`${imgCrop}resize,w_150`" alt="">
          </div>
          <div class="right">
            <div class="name sigle-twoh">{{item.commodity_name, item.rule_type}}</div>
            <div class="price" v-if="item.rule_type=='1'">
                <span class="priceArea" v-if="user.role==0||parseFloat(item['min_sell_price'])-parseFloat(item[`min_${roleText}_price`])==0"><span :style="{fontSize:'.3rem'}">￥{{roleText=='sell'&&item.show_price?item.show_price:item[`min_sell_price`]}}</span></span>
                <span class="priceArea" v-else>￥{{item[`min_${roleText}_price`]}}<!--<span>/赚￥{{parseFloat((parseFloat(item['min_sell_price'])-parseFloat(item[`min_${roleText}_price`])).toFixed(2))}}</span>--></span>
                <div class="toBuy"><div>购买</div></div>
            </div>
            <div class="price" v-if="item.rule_type=='2'">
              <span class="priceArea" v-if="user.new_role==0||parseFloat(item['min_sell_price'])-parseFloat(item[`min_${newRoleText}_price`])==0"><span :style="{fontSize:'.3rem'}">￥{{newRoleText=='sell'&&item.show_price?item.show_price:item[`min_sell_price`]}}</span></span>
              <span class="priceArea" v-else>￥{{item[`min_${newRoleText}_price`]}}<!--<span>/赚￥{{parseFloat((parseFloat(item['min_sell_price'])-parseFloat(item[`min_${roleText}_price`])).toFixed(2))}}</span>--></span>
              <div class="toBuy"><div>购买</div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
     <van-popup v-model="showshare" @click-overlay="colseshare">
       <div class="imgCotainer">
        <img :src="shareImage" alt="" class="swiper-showImg">
       </div>
      </van-popup>
       <div class="hold" v-if="showshare">
          <div @click="wechatShareBtn1">
            <img src="../../assets/images/Sharing_Friends.png"/><br/>
            <span>分享好友</span>
          </div>
          <div @click="wechatShareBtn2">
            <img src="../../assets/images/Sharing_Friends2.png"/><br/>
            <span>分享朋友圈</span>
          </div>
          <div @click="downloadImg">
            <img src="../../assets/images/Save_pictures.png"/><br/>
            <a :dowanload="htmlUrl">下载图片</a>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      playerOptions:{
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        sources: [],
        controlBar: {
          //timeDivider: true,
          //durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
      },
      item:{
        imgArr:[],
      },
      loading:false,
      htmlUrl:[],//截图
      userAvatar:'',
      userName:'',
      shareSwitch:true,
      codeTimer:null, // 二维码定时器
      qrCode:'', //
      showshare:false,
      shareImage:'',
      user:{},
      roleText:'sell',
      newRoleText:'sell',
      isLogin:0,
    }
  },
  watch: {},
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
    playsinline(){
    	var ua = navigator.userAgent.toLocaleLowerCase();
       //x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        return false
      }else{
        //ios端
      return true
      }
    },
    ...mapGetters(["agentText","directorText"])
  },
  methods: {
    full(element){
    //做兼容处理
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    } else if (element.oRequestFullscreen) {
      element.oRequestFullscreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullScreen();
    } else {
      var docHtml = document.documentElement;
      var docBody = document.body;
      var videobox = document.getElementsByClassName("video-player");
      var cssText = "width:100%;height:100%;overflow:hidden;";
      docHtml.style.cssText = cssText;
      docBody.style.cssText = cssText;
      videobox.style.cssText = cssText + ";" + "margin:0px;padding:0px;";
      document.IsFullScreen = true;
    }
  },
  onPlayerCanplay(){
    this.loading = false
    this.full(this.player)
  },
  playVideo(url){
    if(this.loading) return false;
    this.loading = true
    this.playerOptions.sources=[{
      type: "video/mp4",
      src:url
    }]
    setTimeout(()=>{
      this.player.play()
    },500)
  },
   showImage(img, index){
     wx.previewImage({
       current:img[index],
       urls:img
     })
    },
    toCommodity(nbr, rule_type){
      this.$router.push({ path: rule_type=='2'?'/sourceListdetail':"/listdetail", query: { nbr: nbr,supNbr:this.userInfo.nbr } });
    },
    copy(){
      let cbtn= new this.$clipboard('.saveBtn');
      cbtn.on('success',e=>{
        this.$toast({
          message:'文案已复制到剪切板中，请直接粘贴使用。',
          duration:2000,
        })
      })
      cbtn.on('error',e=>{
        this.$toast({
          message:'复制失败',
          duration:2000,
        })
      })
    },
    checkName(name){
      let result = '';
      let nameArr = name.split('');
      let length = name.replace(/[\u0391-\uFFE5]/g,"aa").length;
      if(length >= 4){
        result = nameArr[0] + '**' + nameArr[nameArr.length - 1];
      }else{
        result = name;
      }
      return result;
    },
    getUserRole(){
      this.$commonPost({
        jydm: "flow_10003",
        flow_10003: {
          user_nbr: this.userInfo.nbr
        }
      })
        .then(resp => {
          resp.grade =
            resp.role == "0"
              ? "粉丝"
              : resp.role == "1"
              ? this.agentText
              : resp.role == "2"
              ? this.directorText
              : "总监";
        this.roleText =
          (resp.role == "0"||resp.role == "1")
              ? "sell"
              : resp.role == "2"
              ? "agent"
              : resp.role == "3"
              ? "director"
              : "";
        this.newRoleText =
          (resp.new_role == "0"||resp.new_role == "1")
              ? "sell"
              : resp.new_role == "2"
              ? "agent"
              : resp.new_role == "3"
              ? "director"
              : "";
          this.user = resp;
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    shareScore(){
      this.$commonPost({
        jydm: "flow_10000",
        flow_10000: {
          sub_flow:'flow_150008',
          user_nbr: this.userInfo.nbr,
        }
      })
    },
    goqrcode() {
      if(this.shareImage){
        this.showshare = true;
        return false;
      }
      this.createCommodityCode();
    },
    createCommodityCode(){
      let that = this;
      let toast = that.$toast.loading({
        mask: false,
        message: '获取二维码',
        duration: 0
      });
      that.$post("/api/wechat/gzh/generateNewQRCode", {
        page:'/materialDetail',
        supNbr: that.userInfo.nbr,
        nbr: that.$route.query.nbr,
      }).then(res => {
         let resp = res.object.resp;
         if (res.code == "200") {
           if (resp.resp_code == "0" && resp.resp_result == "0"){
             toast.clear();
             that.qrCode = resp.qrcode;
             that.showshare = true;
             that.shareScore()
             that.cavansImage();
           }
         }
      }).catch(err => {
        that.$toast({
          message: '二维码获取失败，请重试',
          duration: 2000
        });
      });
    },
    cavansImage(){
      let that = this;
      if(!that.shareSwitch) return false;
      that.shareSwitch = false;
      let toast = that.$toast.loading({
        mask: false,
        message: '图片生成中...',
        duration: 0
      });
      let canvas = document.createElement('canvas');
      let imgLoading = false;
      let imgArr = that.item.imgArr;
      if(imgArr.length<4&&imgArr.length>=0){
        let img = new Image();
        img.crossOrigin = "Anonymous"
        img.onload = function () {
          // 画商品图
          canvas.width = 458;
          canvas.height = 824;
          let ctx=canvas.getContext("2d");
          ctx.fillStyle = '#ffffff';
          ctx.rect(0,0,458,824);
          ctx.fillRect(0,0,458,824);
          ctx.fillStyle = '#222222';
          ctx.fillRect(0,0,458,108);
          ctx.restore();
          that.drawImageCover(ctx,img,22,226,424,424)
          that.canvasText(ctx,canvas,toast);
        }
        img.src = imgArr[0]||that.item.comment_video_cover;
      }else if(imgArr.length>=4){
        let img1 = new Image();
        img1.crossOrigin = "Anonymous"
        img1.onload = function () {
          // 画商品图
          canvas.width = 458;
          canvas.height = 824;
          let ctx=canvas.getContext("2d");
          ctx.fillStyle = '#ffffff';
          ctx.rect(0,0,458,824);
          ctx.fillRect(0,0,458,824);
          ctx.fillStyle = '#222222';
          ctx.fillRect(0,0,458,108);
          ctx.restore();
          that.drawImageCover(ctx,img1,22,226,200,200)
          let img2 = new Image();
          img2.crossOrigin = "Anonymous"
          img2.onload = function () {
            // 画商品图
            that.drawImageCover(ctx,img2,236,226,200,200)
            let img3 = new Image();
            img3.crossOrigin = "Anonymous"
            img3.onload = function () {
              // 画商品图
              that.drawImageCover(ctx,img3,22,440,200,200)
              let img4 = new Image();
              img4.crossOrigin = "Anonymous"
              img4.onload = function () {
                // 画商品图
                that.drawImageCover(ctx,img4,236,440,200,200)
                that.canvasText(ctx,canvas,toast);
              }
              img4.src = imgArr[3];
            }
            img3.src = imgArr[2];
          }
          img2.src = imgArr[1];
        }
        img1.src = imgArr[0];
      }
      // that.$toast({
      //     message: '生成图片失败，请重试',
      //     duration: 2000
      // });
    },
    drawImageCover(ctx,img,x,y,w,h){
      if(img.height>img.width){
        ctx.drawImage(img,0,(img.height-img.width)/2,img.width,img.width,x,y,w,h);
      }else{
        ctx.drawImage(img,(img.width-img.height)/2,0,img.height,img.height,x,y,w,h);
      }
      ctx.restore();
    },
    drawText(ctx,text,x,y,w,l,afterText){
       var chr = text.replace('/n','').split("");
        var temp = "";
        var row = [];
        for(var a = 0; a < chr.length; a++){
            if( ctx.measureText(temp).width < w && ctx.measureText(temp+(chr[a])).width <= w){
                temp += chr[a];
            }
            else{
                row.push(temp);
                temp = chr[a];
            }
        }
        row.push(temp);
        // for(var b = 0; b < row.length; b++){
        //     ctx.fillText(row[b],x,y+(b+1)*34);//字体20，间隔24。类似行高
        // }
        // 只显示2行，加...
        for(var b = 0; b < row.length; b++){
            var str = row[b];
            if(b == l-1&&row.length>l){
                str = str.substring(0,str.length-1) + afterText;
            }
            if(b < l){
              ctx.fillText(str,x,y+b*28);
            }
        }
    },
    canvasText(ctx,canvas,toast){
      let that = this;
      let avatar = new Image();
      avatar.crossOrigin = "Anonymous"
      avatar.onload = function () {
        //  画头像
        ctx.save();
        ctx.beginPath();
        ctx.arc(54, 54, 34, 0, 2 * Math.PI);
        ctx.fill();
        ctx.clip();
        ctx.drawImage(avatar,20,20,68,68);
        ctx.restore();
        // 画身份
        // ctx.save();
        // ctx.font = "16px PingFang SC";
        // ctx.textBaseline = "top";
        // let roleWidth = ctx.measureText(that.user.grade).width;
        // ctx.fillStyle = '#ffffff';
        // ctx.beginPath();
        // ctx.arc(113, 73, 11, 0.5 * Math.PI, 1.5 * Math.PI);
        // ctx.moveTo(103+roleWidth,84);
        // ctx.arc(103+roleWidth, 73, 11, 0.5 * Math.PI, 1.5 * Math.PI,true );
        // ctx.rect(113,62,roleWidth-10,22);
        // ctx.strokeStyle="#ffffff";
        // ctx.stroke();
        // ctx.fill();
        // ctx.save();
        // ctx.clip();
        //
        ctx.fillStyle="#333333";
        ctx.fillText(that.user.grade,109,65);
        ctx.restore();
        //  画字
        ctx.save();
        ctx.font = "24px PingFang SC";
        ctx.fillStyle="#ffffff";
        ctx.fillText(that.user.nick_name + '的店铺',102,63);
        ctx.save();
        ctx.fillStyle="#333333";
        ctx.font = "20px PingFang SC";
        ctx.fillText('长按识别二维码',292,798);
        ctx.save();
        ctx.font = "20px bold PingFang SC";
        ctx.fillStyle="#333333";
        that.drawText(ctx,'“'+that.item.content,12,142,424,3,'...”');
        ctx.save();
        ctx.fillStyle="#333333";
        ctx.font = "20px PingFang SC";
        that.drawText(ctx,that.item.commodity_name,22,700,270,2,'...');
        ctx.save();
        ctx.fillStyle="#E52B25";
        ctx.font = "24px bold PingFang SC";
        ctx.fillText('￥',22,798);
        ctx.save();
        ctx.font = "44px bold PingFang SC";
        ctx.fillText(that.item.min_sell_price,45,798);
        // let priceWidth = ctx.measureText('110').width;
        // ctx.save();
        // ctx.font = "30px sans-serif";
        // ctx.fillStyle="#999999";
        // ctx.fillText('￥'+'200',85 + priceWidth ,913);
        // let priceWidth2 = ctx.measureText('￥'+'200').width;
        // ctx.beginPath();
        // ctx.strokeStyle="#999999";
        // ctx.lineWidth = 2;
        // ctx.moveTo(80 + priceWidth,904);
        // ctx.lineTo(priceWidth2 + priceWidth + 100,904);
        ctx.stroke();
        // 画二维码
        let code = new Image();
        code.crossOrigin = "Anonymous"
        code.onload = function (){
          ctx.save();
          ctx.drawImage(code,315,670,100,100);
          ctx.restore();
          ctx.scale(2,2)
          that.shareImage = canvas.toDataURL('image/jpg');
          toast.clear();
          that.shareSwitch = true;
        }
        // if(that.qrCode=='') {
        //   that.shareSwitch = true;
        //   return that.$toast({
        //       message: '二维码获取失败，请稍后再试',
        //       duration: 2000
        //   });
        // }
        code.src = that.qrCode;
      }
      avatar.src = that.user.head_pic;
    },
    // 下载提示
    downloadImg(){
      this.$toast({
        message: '请长按保存图片',
        duration: 2000
      });
    },
    // 分享朋友
    wechatShareBtn1(){
      this.$toast({
        message: '请点击右上角进行分享',
        duration: 2000
      });
    },
    // 分享朋友圈
    wechatShareBtn2(){
      this.$toast({
        message: '请点击右上角进行分享',
        duration: 2000
      });
    },
    colseshare() {
      this.$toast.clear();
      this.showshare = false;
    },
    getData(){
      let toast = this.$toast.loading({
        mask: false,
        duration: 0
      });
      this.$commonPost({
        jydm: "flow_70103",
        flow_70103: {
          nbr: this.$route.query.nbr||'',
          page_index: 0,
          num_per_page: 1
        }
      })
        .then(response => {
          let item = {};
          if (response.list) {
            if (response.list) {
              item = response.list;
            }
          }
          if(item.comment_image){
            item.imgArr = item.comment_image.split(',');
          }else{
            item.imgArr = []
          }
          
          if(item.share_nick_name){
            item.mainName = this.checkName(item.share_nick_name);
          }
          let option = {
            title: item.commodity_name||('有米@'+this.userInfo.name+'的店铺'),
            desc: item.content||'',
            link: `${location.origin}/materialDetail?nbr=${this.$route.query.nbr}&supNbr=${this.userInfo.nbr}`,
            images: item.imgArr[0]||item.comment_video_cover,
          };
          this.weChatShare(option);
          this.item = item;
          toast.clear();
        })
        .catch(err => {
          let option = {
            title: '有米@'+this.userInfo.name+'的店铺',
            desc: '',
            link: `${location.origin}/materialDetail?nbr=${this.$route.query.nbr}&supNbr=${this.userInfo.nbr}`,
          };
          this.weChatShare(option);
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    initPage(){
      if(this.userInfo&&this.userInfo.nbr){
        this.getUserRole();
        this.isLogin = 1;
      }else{
        this.isLogin = 0;
        this.roleText = 'sell';
        this.newRoleText = 'sell';
      }
    },
  },
  created() {
  },
  mounted() {
    window.scrollTo(0 ,0);
    document.title = '素材详情';
    this.getData();
    this.initPage();
  },
 };
 </script>
<style scoped lang='stylus'>
  .van-popup{
    z-index:51 !important;
  }
  .box >>> .van-overlay{
    z-index:50 !important;
  }
</style>
<style scoped lang='less'>
#video{
  width: 0;
  height: 0;
  opacity: 0;
  position: absolute;
  left: -50%;
}
.hold{
  width:100%;
  height:2.48rem;
  background: #FFFFFF;
  border-top-left-radius: .1rem;
  border-top-right-radius: .1rem;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 999999;
  display:flex;
}
.hold div{
  width:2.5rem;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.hold img{
  width:1.2rem;
  height:1.2rem;
  margin-top:0.33rem;
  margin-bottom:0.2rem;
}
.box .van-popup{
  background: none;
  top:38%;
}
.imgCotainer{
  width: 4.58rem;
  height: 8.24rem;
  img{
    width: 100%;
    height: 100%;
  }
}
.sigle-twoh{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.wrapper{
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: .64rem;
  box-sizing:border-box;
}
.mainDetail{
 width: 100%;
 background: #fff;
 padding-top: .2rem;
 padding-bottom: .18rem;
 .head{
  width: 100%;
  height: .8rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding-right: .24rem;
  .left{
    width: .8rem;
    height: 0.8rem;
    padding-left: .24rem;
    .img{
     width: 0.8rem;
     height: 0.8rem;
     border-radius: 50%;
     background: #ccc;
    }
  }
  .right{
    width: calc(100% - 1.04rem);
    height: .8rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: .22rem;
    box-sizing: border-box;
    .name{
     font-size: .3rem;
     font-weight: 700;
     color: #000;
     overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
     width: 100%;
     line-height: .42rem;
    }
    .time{
     margin-top: .05rem;
     font-size: .24rem;
     font-weight: 500;
     color: #999;
    }
  }
 }
 .content{
  margin-top: 0.2rem;
  width: 100%;
  box-sizing: border-box;
  font-size: .28rem;
  color: #333333;
  letter-spacing: 0.6px;
  line-height: .44rem;
  padding: 0 .24rem .4rem;
  font-weight: 500;
 }
 .imgArr{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .title{
   width: 100%;
   text-align: center;
   line-height: .48rem;
   color: #bbb;
   font-size: .34rem;
   font-weight: 700;
   position: relative;
   &:before{
    content:'';
    position: absolute;
    width: .6rem;
    height: .04rem;
    border-radius: .02rem;
    background: #999;
    bottom: -.1rem;
    left: 50%;
    transform: translateX(-50%);
   }
  }
    .loading{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.1);
    .loadingIcon{
      width: .4rem;
      height: .4rem;
    }
  }
  .player{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 1rem;
    height: 1rem;
    box-sizing: border-box;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #E8E8E8;
    background-color: rgba(0,0,0,0.5);
    .playIcon{
      width:.4rem !important;
      height:.4rem !important;
      margin-left: .1rem;
    }
  }
  .imgContainer1{
   margin-top: .32rem;
   padding-bottom: .2rem;
   width: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   .img{
    width: 4rem;
    height:4rem;
    border-radius:.1rem;
    display:flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    img{
      width: 4rem;
      height:4rem;
      object-fit:cover;
    }
   }
  }
  .imgContainer2{
   margin-top: .32rem;
   padding-bottom: .2rem;
   width: 5.8rem;
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: row;
   .img{
    width: 2.8rem;
    height:2.8rem;
    display:flex;
    border-radius:.1rem;
    margin-right: .1rem;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    img{
      width: 2.8rem;
      height:2.8rem;
      object-fit:cover;
     }
     &:last-child{
     margin-right: 0;
     }
    }
  }
  .imgContainer4{
   margin-top: .32rem;
   width: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   flex-flow: row wrap;
   .img{
    width: 2.8rem;
    height:2.8rem;
    display:flex;
    border-radius:.1rem;
    margin-right: .1rem;
    margin-bottom: .1rem;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    img{
      width: 2.8rem;
      height:2.8rem;
      object-fit:cover;
    }
    &:nth-child(2n){
     margin-right: 0;
    }
   }
  }
  .imgContainerOther{
   width: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   flex-flow: row wrap;
   margin-top: .32rem;
   .img{
     width: 2.2rem;
     height:2.2rem;
     display: flex;
     justify-content: center;
     align-items: center;
     overflow: hidden;
     margin-right: 0.1rem;
     margin-bottom: .2rem;
     border-radius:.1rem;
     position: relative;
     img{
     width: 2.2rem;
     height:2.2rem;
     object-fit:cover;
    }
   &:nth-child(3n){
     margin-right: 0;
    }
   }
   
   .hidden{
     visibility: hidden;
   }
  }
 }
 .share{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: .68rem;
  padding: 0 .24rem;
  box-sizing:border-box;
  .left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img{
     width: 0.5rem;
     height: 0.5rem;
     border-radius: 50%;
     margin-right: .1rem;
    }
    div{
     font-size: .48rem;
     color: #999999;
     font-weight: 500;
     display: flex;
     align-items: center;
     white-space:nowrap;
     transform: scale(0.5);
     transform-origin: left;
    }
  }
  .right{
    display: flex;
    justify-content: flex-start;
    align-items: center;
   .saveBtn{
    width: 1.28rem;
    height: 0.48rem;
    border: 1px solid #333;
    border-radius: .24rem;
    box-sizing:border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    div{
     color: #333;
     display: flex;
     justify-content: center;
     align-items: center;
     height: 0.48rem;
     font-size: .48rem;
     font-weight: 500;
     transform:scale(0.5);
     white-space:nowrap;
    }
   }
   .shareBtnC{
     width: 1.28rem;
     margin-left: .14rem;
   }
   .shareBtn{
    width: 2.56rem;
    height: .96rem;
    background-image: linear-gradient(-90deg, #FD3741 0%, #FE7202 100%);
    border-radius: .48rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: scale(0.5);
    transform-origin: left;
    img{
     width: .52rem;
     height: 0.52rem;
     margin-right: .1rem;
    }
    span{
     color: #fff;
     font-size: .48rem;
     font-weight: 500;
    }
   }
  }
 }
}
.otherDetail{
 margin-top: .2rem;
 height: 2.82rem;
 background: #fff;
 .title{
  width: 100%;
  height: .88rem;
  display: flex;
  align-items: center;
  color: #101010;
  font-weight: 500;
  font-size: 0.3rem;
  box-sizing: border-box;
  padding-left: .4rem;
  position: relative;
  &:after{
   content:'';
   position: absolute;
   width: 0.06rem;
   height: 0.28rem;
   background: #E52B25;
   left: .24rem;
   top: 50%;
   transform: translateY(-50%);
  }
 }
 .commodity{
  width: 100%;
  box-sizing:border-box;
  padding: .06rem .24rem .3rem;
  .commodityItem{
   display: flex;
   justify-content: center;
   align-items: center;
   background: #f8f8f8;
   border-radius: .18rem;
   height: 1.58rem;
   .left{
    width: 1.3rem;
    height: 1.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
     width: 1.3rem;
     height: 1.3rem;
     border-radius: .16rem;
     object-fit: cover;
    }
   }
   .right{
     width: calc(100% - 1.68rem);
     padding-left: .1rem;
     height: 1.3rem;
     display: flex;
     flex-direction: column;
     justify-content: space-between;
     box-sizing: border-box;
     .name{
      width: 100%;
      line-height: 0.34rem;
      font-size: .24rem;
      color: #333;
      font-weight: 700;
      letter-spacing: 0.51px;
     }
     .price{
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .priceArea{
       font-size: .3rem;
       color: #333;
       letter-spacing: .64px;
       font-weight: 700;
       span{
        color: #E52B25;
        font-size: .24rem;
       }
      }
      .toBuy{
        background: #E52B25;
        width: 1rem;
        height: 0.4rem;
        border-radius: .2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.2rem;
        div{
         font-weight: 700;
         font-size: 0.48rem;
         color: #fff;
         letter-spacing: 1px;
         display: flex;
         align-items: center;
         white-space:nowrap;
          transform: scale(0.5);
        }
      }
     }
   }
  }
 }
}
</style>



// WEBPACK FOOTER //
// src/components/index/materialDetail.vue